import React, { useEffect, useState } from 'react';
import Header from '../composant/Header';
import '../styles/SiteVitrine.css';
import HeroSection from '../composant/HeroSection';
import HowItWorks from '../composant/HowItWorks';
import DemandeInscription from '../composant/DemandeInscription';
import InfluenceursCibles from '../composant/InfluenceursCibles';
import FooterPage from '../composant/Footer';

const SiteVitrine = () => {


  return (
    <div>
      <Header />
      <HeroSection />
      <HowItWorks />
      <InfluenceursCibles />
      <DemandeInscription />
      <FooterPage />
    </div>
  );
};

export default SiteVitrine;
